import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { AppModels, AppState, appUrl, brandSelector, selectProductByBrand } from 'cdx-common';
import { useSelector } from 'react-redux';
import { MainViewLoader } from '../../libraries/MainViewLoader';
import { AppItem } from '../AppItems';

export const BrandProductList = (props: { brandId: ModelId; }) => {
    return <MainViewLoader
        modelId={props.brandId}
        selector={brandSelector}
        path={appUrl('productList', null, { brandId: props.brandId })}>
        <LoadedBrandProducts brandId={props.brandId} />
    </MainViewLoader>;
};

const LoadedBrandProducts = (props: { brandId: ModelId; }) => {
    const relatedPorducts = useSelector((state: AppState) => selectProductByBrand(state, props.brandId));
    return <List>
        {relatedPorducts.length == 0 ? <ListItem><ListItemText primary={'Aucun produit'} /></ListItem> : null}
        {relatedPorducts.map(product => <ListItem key={product.id}>
            <ListItemButton href={'product/' + product.id}>
                <AppItem type={AppModels.products} id={product.id} />
            </ListItemButton>
        </ListItem>)}
    </List>;
};
